// Based on solution in - https://css-tricks.com/using-css-transitions-auto-dimensions/

import SelectorFilter from "./selector-filter";
import Tooltip from "./tooltip";

export default class SlideToggle {

	private triggers: HTMLElement[];
	private doneClass = 'js-slide-toggle-done';

	constructor() {
		this.init();
	}

	public init() {

		this.triggers = SelectorFilter.excludeByClass(document.querySelectorAll('.js-slide-toggle'), this.doneClass);

		if (!this.triggers.length) return;

		this.openFromHash();

		this.styleOpenTriggers();

		this.triggerClicks();

	}

	private openFromHash() {
		const hash = window.location.hash;
		if (!hash) {
			return;
		}
		const trigger = document.querySelector(hash) as HTMLElement;
		if (!trigger) {
			return;
		}
		trigger.setAttribute('aria-expanded', 'true');
		const targetSelector = trigger.getAttribute('aria-controls');
		const target = document.querySelector('#' + targetSelector) as HTMLElement;
		const transitionTime = parseInt(trigger.getAttribute('data-transition-time')) || 0;
		this.open(target, transitionTime);
	}

	private styleOpenTriggers() {

		for (let i = 0; i < this.triggers.length; i++) {

			const isExpanded = this.triggers[i].getAttribute('aria-expanded') === 'true';

			if (isExpanded) {

				const target = document.querySelector('#' + this.triggers[i].getAttribute('aria-controls')) as HTMLElement;
				target.classList.add('is-open');
				target.style.height = 'auto';
				target.setAttribute('aria-hidden', 'false');

			}

		}

	}

	private triggerClicks() {

		let allowClick = true;

		for (let i = 0; i < this.triggers.length; i++) {

			this.triggers[i].addEventListener('click', (e) => {

				if (!allowClick) return;

				allowClick = false;

				const eventTarget = e.currentTarget as HTMLLinkElement;
				const isExpanded = eventTarget.getAttribute('aria-expanded') === 'false';
				const shouldOpen = isExpanded || eventTarget.getAttribute('data-slide-toggle-open') === 'true';
				const ariaControls = eventTarget.getAttribute('aria-controls');
				const target = document.querySelector('#' + ariaControls) as HTMLElement;
				const transitionTime = parseInt(eventTarget.getAttribute('data-transition-time')) || 0;

				if (shouldOpen) {

					this.open(target, transitionTime);
					this.setAriaExpanded(ariaControls, true);

				} else {

					this.close(target, transitionTime);
					this.setAriaExpanded(ariaControls, false);

				}

				setTimeout(()=> { allowClick = true; }, transitionTime); 

				this.openRevealChildren(target);

				e.stopPropagation();

			});

			this.triggers[i].classList.add(this.doneClass);

		}

	}

	private setAriaExpanded(ariaControls: string, expanded: boolean) {

		const elements = document.querySelectorAll('[aria-controls="' + ariaControls + '"]');
		for (let i = 0; i < elements.length; i++) { elements[i].setAttribute('aria-expanded', expanded.toString()); }

	}

	private open(target: HTMLElement, transitionTime: number) {

		if (!target) {
			return;
		}

		target.setAttribute('aria-hidden', 'false');
		const height = target.scrollHeight;
		target.style.height = height + 'px';
		target.classList.add('is-open');

		setTimeout(()=> { target.style.height = 'auto'; }, transitionTime);

		this.openRevealChildren(target);

	}

	private close(target: HTMLElement, transitionTime: number) {

		if (!target) {
			return;
		}

		if (typeof Tooltip !== "undefined") {
			Tooltip.hideTooltips();
			Tooltip.resetTriggers();
		}
		
		const height = target.scrollHeight;

		const targetTransition = target.style.transition;
		target.style.transition = '';

		requestAnimationFrame(()=> {

			target.style.height = height + 'px';
			target.style.transition = targetTransition;

			requestAnimationFrame(() => {
				target.style.height = 0 + 'px';
			});

		});

		setTimeout(() => {
			target.classList.remove('is-open');
			target.setAttribute('aria-hidden', 'true');
		}, transitionTime);

	}

	private openRevealChildren(wrapper: HTMLElement) {

		const reveal = wrapper.querySelector('.js-reveal-content[aria-expanded="false"]');

		if (reveal) {
			const revealButton = reveal.querySelector('.js-reveal-content-button') as HTMLButtonElement;
			if (revealButton) {
				revealButton.click();
			}
		}

	}

}

